<template>
  <div id="app">
    <!-- Bootstrap Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow-sm app-header">
      <div class="container-fluid">

        <!-- Mobile Offcanvas Toggle -->
        <button class="navbar-toggler me-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu"
          aria-controls="sidebarMenu" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Branding -->
        <router-link class="navbar-brand d-flex align-items-center me-lg-auto" to="/">
          <!-- me-lg-auto pushes desktop nav right -->
          <img src="/img/icons/android-chrome-192x192.png" alt="Logo" width="30" height="30"
            class="d-inline-block align-text-top me-2">

        </router-link>

        <!-- Desktop Navbar Links (collapsible part - hidden on mobile) -->
        <div class="collapse navbar-collapse d-none d-lg-flex" id="desktopNav"> <!-- Use BS classes to hide/show -->
          <ul class="navbar-nav"> <!-- me-auto removed, spacing handled by parent flex -->
            <li class="nav-item"> <router-link class="nav-link" active-class="active" to="/">Accueil</router-link> </li>
            <li class="nav-item"> <router-link class="nav-link" active-class="active" to="/dossier">Nouveau
                Dossier</router-link> </li>
            <li class="nav-item"> <router-link class="nav-link" active-class="active" to="/todos">Suivi
                Tâches</router-link> </li>
            <li class="nav-item"> <router-link class="nav-link" active-class="active" to="/discussions">Discussions
                Diag.</router-link> </li>
            <li class="nav-item">
              <router-link class="nav-link" active-class="active" to="/annuaire">Annuaire</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" active-class="active" to="/calculators">Calculateurs</router-link>
            </li>
          </ul>
        </div>

        <!-- Right-aligned Actions (Theme Toggle + User/Login) -->
        <!-- This container is always visible, items align based on screen size -->
        <div class="d-flex align-items-center header-actions ms-auto"> <!-- ms-auto pushes right -->
          <!-- Theme Toggle Button -->
          <button @click="toggleTheme" class="btn btn-sm theme-toggle me-2"
            :title="'Mode ' + (currentTheme === 'light' ? 'Sombre' : 'Clair')">
            <svg v-if="currentTheme === 'light'" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
              <path fill="currentColor"
                d="M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 64H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H391L371.4 195.9c-1 5.3-4.6 9.8-9.6 11.9L256 256l105.8 48.2c5 2.1 8.6 6.6 9.6 11.9L391 384H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H391L371.4 498.1c-1 5.3-4.6 9.8-9.6 11.9L256 512l-105.8-48.2c-5-2.1-8.6-6.6-9.6-11.9L121 448H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h59l19.6-68.1c1-5.3 4.6-9.8 9.6-11.9L256 256l-105.8-48.2c-5-2.1-8.6-6.6-9.6-11.9L121 128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h59l19.6-68.1c1-5.3 4.6-9.8 9.6-11.9L256 0l105.5 1.2zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
              <path fill="currentColor"
                d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z" />
            </svg>
          </button>

          <!-- User Info / Logout/Login -->
          <div class="user-info d-flex align-items-center" v-if="userSession">
            <span class="navbar-text d-none d-sm-inline me-2 user-email">{{ userEmail }}</span>
            <button @click="handleLogout" class="btn btn-sm logout-button" title="Déconnexion">
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                <path fill="currentColor"
                  d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" />
              </svg>
            </button>
          </div>
          <router-link v-else to="/login" class="btn btn-sm btn-outline-primary ms-2">Connexion</router-link>
        </div>

      </div>
    </nav>

    <!-- Bootstrap Offcanvas Sidebar -->
    <!-- Ensure the offcanvas has the correct ID and structure -->
    <div class="offcanvas offcanvas-start" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
      <div class="offcanvas-header border-bottom">
        <h5 class="offcanvas-title" id="sidebarMenuLabel">Menu</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <!-- Content SHOULD appear here -->
        <nav class="nav flex-column sidebar-nav">
          <router-link class="nav-link" active-class="active" to="/" @click="closeOffcanvasManual">Accueil</router-link>
          <router-link class="nav-link" active-class="active" to="/dossier" @click="closeOffcanvasManual">Nouveau
            Dossier</router-link>
          <router-link class="nav-link" active-class="active" to="/todos" @click="closeOffcanvasManual">Suivi
            Tâches</router-link>
          <router-link class="nav-link" active-class="active" to="/discussions"
            @click="closeOffcanvasManual">Discussions Diag.</router-link>
          <router-link class="nav-link" active-class="active" to="/annuaire"
            @click="closeOffcanvasManual">Annuaire</router-link>
          <router-link class="nav-link" active-class="active" to="/calculators" @click="closeOffcanvasManual">Calculateurs</router-link>
          <hr class="my-2">
          <button v-if="userSession" @click="handleLogoutAndCloseOffcanvas"
            class="btn btn-sm btn-outline-secondary w-100 mt-2">Déconnexion</button>
          <router-link v-else to="/login" class="btn btn-sm btn-primary w-100 mt-2" @click="closeOffcanvasManual">Se
            connecter</router-link>
        </nav>
        <!-- Add theme toggle also in sidebar for mobile -->
        <hr class="my-3">
        <div class="d-flex justify-content-center">
          <button @click="toggleTheme" class="btn btn-sm theme-toggle"
            :title="'Mode ' + (currentTheme === 'light' ? 'Sombre' : 'Clair')">
            <svg v-if="currentTheme === 'light'" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
              <path fill="currentColor"
                d="M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 64H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H391L371.4 195.9c-1 5.3-4.6 9.8-9.6 11.9L256 256l105.8 48.2c5 2.1 8.6 6.6 9.6 11.9L391 384H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H391L371.4 498.1c-1 5.3-4.6 9.8-9.6 11.9L256 512l-105.8-48.2c-5-2.1-8.6-6.6-9.6-11.9L121 448H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h59l19.6-68.1c1-5.3 4.6-9.8 9.6-11.9L256 256l-105.8-48.2c-5-2.1-8.6-6.6-9.6-11.9L121 128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h59l19.6-68.1c1-5.3 4.6-9.8 9.6-11.9L256 0l105.5 1.2zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
              <path fill="currentColor"
                d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- Main Content Area -->
    <main class="main-content container-fluid py-3 py-md-4">
      <router-view :session="userSession" />
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { supabase } from '../supabase'; // Adjust path if needed
import router from './router'; // Adjust path if needed
import { Offcanvas } from 'bootstrap'; // Import Offcanvas JS instance if needed for manual control

const userSession = ref(null);
const userEmail = computed(() => userSession.value?.user?.email || 'N/A');
let bsOffcanvas = null; // To hold the Bootstrap Offcanvas instance
// --- Dark Mode State ---
const currentTheme = ref(localStorage.getItem('theme') || 'light'); // Default to light

onMounted(() => {
  // Initialize Bootstrap Offcanvas JS component
  const sidebarElement = document.getElementById('sidebarMenu');
  document.documentElement.setAttribute('data-theme', currentTheme.value);
  if (sidebarElement) {
    bsOffcanvas = new Offcanvas(sidebarElement);
  }

  // --- Auth Logic (remains the same) ---
  supabase.auth.getSession().then(({ data: { session } }) => { userSession.value = session; });
  supabase.auth.onAuthStateChange((_event, session) => {
    console.log('Auth State Change:', _event);
    userSession.value = session;
    const currentRoute = router.currentRoute.value;
    if (!session && currentRoute.meta.requiresAuth) { router.push({ name: 'login' }); }
    else if (session && currentRoute.name === 'login') { router.push({ name: 'home' }); }
  });
});


// --- Logout Logic ---
const handleLogout = async () => {
  console.log('handleLogout called'); // Debug log
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    console.log('SignOut successful');
    // Explicitly navigate to login AFTER signout completes.
    // onAuthStateChange will also fire, but this ensures immediate redirection.
    router.push({ name: 'login' });
  } catch (error) {
    console.error('Logout Error:', error);
    alert('Erreur lors de la déconnexion: ' + error.message);
  }
};
// --- Offcanvas Control ---
// Bootstrap handles toggle via data attributes, manual close might be needed on link click
const closeOffcanvasManual = () => {
  bsOffcanvas?.hide(); // Use Bootstrap JS instance to hide
};

const handleLogoutAndCloseOffcanvas = () => {
  handleLogout();
  closeOffcanvasManual();
};
// --- Method to toggle theme ---
const toggleTheme = () => {
  const newTheme = currentTheme.value === 'light' ? 'dark' : 'light';
  currentTheme.value = newTheme;
  document.documentElement.setAttribute('data-theme', newTheme);
  localStorage.setItem('theme', newTheme); // Persist choice
};


// Close offcanvas automatically on route change
watch(() => router.currentRoute.value.path, () => {
  closeOffcanvasManual();
});

</script>

<style>
/* Minimal global styles needed now */
body {
  background-color: #f0f2f5;
  /* Light background */
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex-grow: 1;
}

/* Bootstrap Navbar Customization (Optional) */
.navbar {
  min-height: var(--header-height, 55px);
  /* Adjust height if needed */
}

.navbar-brand {
  font-weight: 600;
  color: var(--primary-color, #0d6efd) !important;
  /* Force color */
}

.navbar-nav .nav-link.active {
  font-weight: 500;
  /* Bootstrap handles active color */
}

/* Offcanvas Customization (Optional) */
.offcanvas-start {
  width: var(--sidebar-width, 260px);
  /* Consistent width */
}

.offcanvas-body .nav-link {
  color: var(--text-color, #212529);
  padding: 0.75rem 1rem;
  /* Adjust padding */
  font-size: 1rem;
}

.offcanvas-body .nav-link:hover {
  background-color: var(--light-color, #f8f9fa);
}

.offcanvas-body .nav-link.active {
  color: var(--primary-color, #0d6efd);
  font-weight: 500;
  background-color: rgba(var(--primary-color-rgb, 13, 110, 253), 0.1);
}

.offcanvas-body hr {
  margin: 1rem 0;
}

/* Ensure form styles apply globally if needed (or scope them) */
/* Example: Add some margin to form wrappers */
.form-section-wrapper,
.patient-list-section,
.selected-dossier-section {
  margin-bottom: 2rem;
  /* Consistent margin */
}

/* You might need slight adjustments for specific form elements if Bootstrap */
/* default styles conflict with your previous layout expectations. */
.form-group label {
  margin-bottom: 0.5rem;
  /* Bootstrap standard */
  font-size: 0.9em;
  /* Slightly smaller labels */
  color: #495057;
  /* Bootstrap muted text */
  font-weight: 500;
}

.radio-group,
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  /* Allow wrapping by default */
  gap: 1rem;
  /* Bootstrap gap */
  padding-top: 0.25rem;
}

.radio-group label,
.checkbox-group label {
  margin-bottom: 0;
  /* Remove default */
  display: flex;
  align-items: center;
  font-weight: normal;
}

input[type="radio"],
input[type="checkbox"] {
  margin-right: 0.5rem;
  transform: scale(1.0);
  /* Back to normal scale */
  accent-color: var(--primary-color);
}

/* Adjust nested details padding */
.nested-details {
  margin-left: 0.5rem;
  padding: 0.75rem;
  border: 1px solid #eee;
  border-radius: 0.25rem;
  margin-top: 0.75rem;
  background-color: #fdfdfd;
}

/* Adjust output pre styling if needed */
.output {
  font-size: 0.85em;
  padding: 1rem;
  background-color: #e9ecef;
  /* Bootstrap secondary bg */
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #212529;
  max-height: 60vh;
  /* Limit height */
  overflow: auto;
}

/* List item actions */
.list-item-actions {
  margin-top: 0.5rem;
  /* Add some space on mobile */
}

@media (min-width: 768px) {
  .list-item-actions {
    margin-top: 0;
  }
}

/* --- Dark Theme Overrides (Global Scope) --- */
/* We use html[data-theme='dark'] for higher specificity over Bootstrap defaults */

html[data-theme='dark'] body {
  color: var(--text-color);
  /* From :root[data-theme=dark] */
  background-color: var(--background-color);
  /* From :root[data-theme=dark] */
}

/* Navbar */
html[data-theme='dark'] .navbar-light {
  background-color: var(--component-background) !important;
  /* Override BS .bg-light */
  border-bottom-color: var(--border-color-light) !important;
}

html[data-theme='dark'] .navbar-brand {
  color: var(--primary-color) !important;
}

html[data-theme='dark'] .navbar-nav .nav-link {
  color: var(--nav-link-color) !important;
  /* Use CSS var */
}

html[data-theme='dark'] .navbar-nav .nav-link:hover {
  color: var(--nav-link-hover-color) !important;
}

html[data-theme='dark'] .navbar-nav .nav-link.active {
  color: var(--nav-link-active-color) !important;
}

html[data-theme='dark'] .navbar-toggler {
  border-color: var(--border-color);
}

/* SVG icon for toggler - requires encoding the SVG */
html[data-theme='dark'] .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(222, 226, 230, 0.75)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

html[data-theme='dark'] .navbar-text {
  color: var(--text-color-muted) !important;
  /* White text */
}

/* Offcanvas Sidebar */
html[data-theme='dark'] .offcanvas {
  background-color: #343a40 !important;
  /* Dark background */
  color: #fff !important;
  /* White text */
  border-right-color: #495057 !important;
}

html[data-theme='dark'] .offcanvas-header {
  background-color: #343a40 !important;
  /* Dark header */
  border-bottom-color: #495057 !important;
}

html[data-theme='dark'] .offcanvas-title {
  color: #fff !important;
}

html[data-theme='dark'] .offcanvas-body {
  background-color: #343a40 !important;
  /* Match header */
}

html[data-theme='dark'] .offcanvas-body .nav-link {
  color: #dee2e6 !important;
  /* Light gray text */
}

html[data-theme='dark'] .offcanvas-body .nav-link:hover {
  color: #fff !important;
  background-color: #495057 !important;
  /* Slightly lighter dark on hover */
}

html[data-theme='dark'] .offcanvas-body .nav-link.active {
  color: #fff !important;
  background-color: var(--primary-color-dark) !important;
  /* Use a defined dark primary */
  font-weight: bold;
}

html[data-theme='dark'] .offcanvas-header .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%) !important;
  /* Make white */
}

html[data-theme='dark'] .offcanvas-body hr {
  border-top-color: #495057 !important;
}

/* Modal Content */
html[data-theme='dark'] .modal-content {
  background-color: var(--component-background) !important;
  color: var(--text-color) !important;
  border-color: var(--border-color-light) !important;
}

html[data-theme='dark'] .modal-header,
html[data-theme='dark'] .modal-footer {
  border-color: var(--border-color-light) !important;
}

/* Ensure text inside modal body is also themed */
html[data-theme='dark'] .modal-body {
  color: var(--text-color) !important;
}

html[data-theme='dark'] .modal-body .text-muted {
  color: var(--text-color-muted) !important;
}

html[data-theme='dark'] .modal-body .output {
  /* Style <pre> inside modal */
  background-color: var(--component-background-alt) !important;
  border-color: var(--border-color) !important;
  color: var(--text-color) !important;
}

html[data-theme='dark'] .modal-body .evolution-item {
  background-color: var(--component-background-alt) !important;
  border-color: var(--border-color) !important;
}


/* Theme Toggle Button */
.theme-toggle {
  color: var(--text-color-muted);
  border: 1px solid var(--border-color);
  background: none;
  border-radius: 50%;
  /* Make it round */
  width: 34px;
  /* Fixed size */
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
}

.theme-toggle:hover {
  background-color: var(--component-background-alt);
  border-color: var(--secondary-color);
  color: var(--text-color);
}

.theme-toggle svg {
  height: 1.1em;
  width: 1.1em;
  vertical-align: middle;
  display: block;
  fill: currentColor;
}

/* Logout Button */
.logout-button {
  padding: 5px 8px;
  line-height: 1;
  border: none;
  background: none;
  color: var(--secondary-color);
}

.logout-button:hover {
  color: var(--danger-color);
  background-color: rgba(var(--danger-color-rgb, 220, 53, 69), 0.1);
}

.logout-button svg {
  width: 1em;
  height: 1em;
  margin: 0;
  fill: currentColor;
}

/* User Email */
.user-email {
  font-size: 0.8rem;
  color: var(--text-color-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  /* Limit width */
}
</style>